module.exports = __webpack_public_path__ + "img/banner-hen-ja.0d1e3ec5.png";